import { ControlBar } from "../components/control-bar";
import { Lang } from "@/data/translation";
import { ChartComponentParams } from "@/types/chart";
import { useEffect, useState } from "react";

export type ChartControllerParams = {
  lang: Lang;
  isControllable: ChartComponentParams["isControllable"];
  range: ChartComponentParams["range"];
  rangeOptions: ChartComponentParams["rangeOptions"];
  timeFrame: ChartComponentParams["timeFrame"];
  timeFrameOptions: ChartComponentParams["timeFrameOptions"];
};

export const useTimeFrameController = ({
  lang,
  isControllable,
  range,
  rangeOptions,
  timeFrame,
  timeFrameOptions,
}: ChartControllerParams) => {
  const [currentTimeFrame, setCurrentTimeFrame] = useState(timeFrame ?? "Y");
  const [currentRange, setCurrentRange] = useState(range ?? "5y");

  const showControlBar =
    isControllable &&
    range &&
    rangeOptions &&
    currentTimeFrame &&
    timeFrameOptions;

  useEffect(() => {
    setCurrentTimeFrame(timeFrame ?? "Y");
  }, [timeFrame]);

  const TimeFrameController = () =>
    showControlBar ? (
      <ControlBar
        lang={lang}
        {...{
          range: currentRange,
          setRange: setCurrentRange,
          timeFrame: currentTimeFrame,
          setTimeFrame: setCurrentTimeFrame,
          rangeOptions,
          timeFrameOptions,
        }}
      />
    ) : null;

  return {
    currentRange,
    currentTimeFrame,
    TimeFrameController,
  };
};
